import React from 'react'
import TextEditor from './TextEditor';
import Cookies from 'universal-cookie';
import db from './db';
import HubUpdateTable from './HubUpdateTable'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

//let globalSystemSettings=[];

// SystemSettingsEditor component
export default class SystemSettingsEditor extends React.Component {

    cookies = new Cookies();

    // initialize the SystemSettingsEditor Component
    static init(stateObject){
        stateObject.systemSettings = undefined;
    }
    
    // initialize the Component
    constructor(props) {
        super(props);
        this.state={
            systemSettingsEditorModified : false,
            systemSettingsPostSettings:{}
        }
    }    

    // render
    render() {

        // render data
        return( 
            (this.props.securityObject.systemSettings) ? (
                <div>
                    <Tabs defaultIndex={this.props.tabIndex} onSelect={index => console.log(index)}>
                        <TabList>
                            <Tab>JSON Debugger</Tab>
                            <Tab>Local Settings</Tab>
                            <Tab>Hub Rules</Tab>
                            <Tab>Note Types</Tab>
                            <Tab>Shipping Labels</Tab>
                            <Tab>SQL Reports</Tab>
                            <Tab>mac/system type</Tab>
                            <Tab>Hub Updates</Tab>
                        </TabList>                    
                        <TabPanel>
                            <TextEditor
                                label="JSON Editor"
                                id="json_editor" 
                                name="json_editor" 
                                className="JsonTextArea" 
                                type="json"                            
                            ></TextEditor>
                        </TabPanel>
                        <TabPanel>
                            <label>Bad Battery Threshold</label>
                            <input defaultValue={this.cookies.get('BadBatteryThreshold')} onChange={this.updateBadBatteryThreshold.bind(this)}/>
                            <br></br>
                        </TabPanel>
                        <TabPanel>
                            <h3>
                                MAKE THESE CHANGES IN GITHUB PROJECT wave-device-tracking-app\sql THEN RUN SQL SCRIPT IN DATABASE &nbsp;
                                <a href="https://github.com/wave-dds/wave-device-tracking-app/blob/main/sql/settings-hub_rules.sql" target="_blank" rel="noopener noreferrer">script</a>
                            </h3>
                            <TextEditor
                                label="Hub Rules"
                                id="hub_rules" 
                                name="hub_rules" 
                                className="JsonTextArea" 
                                type="json"                            
                                defaultValue={this.props.securityObject.systemSettings.hub_rules} 
                            ></TextEditor>
                        </TabPanel>
                        <TabPanel>
                            <h3>
                                MAKE THESE CHANGES IN GITHUB PROJECT wave-device-tracking-app\sql THEN RUN SQL SCRIPT IN DATABASE &nbsp;
                                <a href="https://github.com/wave-dds/wave-device-tracking-app/blob/main/sql/settings-note_type_list.sql" rel="noopener noreferrer" target="_blank" >script</a>
                            </h3>
                            <TextEditor
                                label="Note Types"
                                id="note_type_list" 
                                name="note_type_list" 
                                className="JsonTextArea" 
                                type="json"                            
                                defaultValue={this.props.securityObject.systemSettings.note_type_list} 
                            ></TextEditor>
                        </TabPanel>
                        <TabPanel>
                            <h3>
                                MAKE THESE CHANGES IN GITHUB PROJECT wave-device-tracking-app\sql THEN RUN SQL SCRIPT IN DATABASE &nbsp;
                                <a href="https://github.com/wave-dds/wave-device-tracking-app/blob/main/sql/settings-shipping_labels.sql" rel="noopener noreferrer" target="_blank">script</a>
                            </h3>
                            <TextEditor
                                label="Shipping Labels"
                                id="shipping_labels" 
                                name="shipping_labels" 
                                className="JsonTextArea" 
                                type="json"                            
                                defaultValue={this.props.securityObject.systemSettings.shipping_labels} 
                            ></TextEditor>
                        </TabPanel>
                        <TabPanel>
                            <h3>
                                MAKE THESE CHANGES IN GITHUB PROJECT wave-device-tracking-app\sql THEN RUN SQL SCRIPT IN DATABASE &nbsp;
                                <a href="https://github.com/wave-dds/wave-device-tracking-app/blob/main/sql/settings-sql_reports.sql" rel="noopener noreferrer" target="_blank">script</a>
                            </h3>
                            <TextEditor
                                label="SQL Reports"
                                id="sql_reports" 
                                name="sql_reports" 
                                className="JsonTextArea" 
                                type="json"                            
                                defaultValue={this.props.securityObject.systemSettings.sql_reports} 
                            ></TextEditor>
                        </TabPanel>
                        <TabPanel>
                            <h3> 
                                this list is derived from the following query:<br />
                            </h3>
                            <code> 
                                select * from v_mac_to_system_type
                            </code>
                            <TextEditor
                                label="mac/System Types"
                                id="mac_system_type" 
                                name="mac_system_type" 
                                className="JsonTextArea" 
                                type="json"                            
                                defaultValue={JSON.stringify(this.props.securityObject.systemSettings.mac_to_system_type)} 
                            ></TextEditor>
                        </TabPanel>
                        <TabPanel>
                            <HubUpdateTable
                                securityObject={this.props.securityObject}
                                >
                            </HubUpdateTable>
                        </TabPanel>
                    </Tabs>
                </div>
            ) :""
        );
    }
    // update an editor
    updateSystemSettingsInputValue(evt){
        let systemSettingsPostSettings = this.state.systemSettingsPostSettings;
        systemSettingsPostSettings[evt.currentTarget.name] = evt.currentTarget.value;         
        this.setState({
            systemSettingsEditorModified : true,
            systemSettingsPostSettings : systemSettingsPostSettings
        });        
    }

    // save the settings
    saveSystemSettings(){
        db.saveData( this.props.securityObject,
                        this.state.systemSettingsPostSettings
                        ,"api/updateSystemSettings"
                        , function(res){
                            // set screen values
                            this.setState({
                                systemSettingsEditorModified:false,
                                systemSettingsPostSettings:{}
                            });

                            // uppdate securityObject
                            db.getSystemSettings( this.props.securityObject
                                , async results =>{
                                    this.props.securityObject.systemSettings = results;
                                }
                            );
                        }
                    );
    }

    // set the cookie to change the Bad Battery Threshold
    updateBadBatteryThreshold(e){
        this.setState({
            hubErrorsBadBatteryThreshold:e.target.value
        })
        this.cookies.set('BadBatteryThreshold', e.target.value);        
    }    
}
